import { render, staticRenderFns } from "./comentario_item.vue?vue&type=template&id=fadcd2f2&"
import script from "./comentario_item.vue?vue&type=script&lang=js&"
export * from "./comentario_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fadcd2f2')) {
      api.createRecord('fadcd2f2', component.options)
    } else {
      api.reload('fadcd2f2', component.options)
    }
    module.hot.accept("./comentario_item.vue?vue&type=template&id=fadcd2f2&", function () {
      api.rerender('fadcd2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/topicos/comentario_item.vue"
export default component.exports